import {
  LegalFooter,
  PPlannerPayment,
  UiModal,
  PrivacyPolicy,
  SummaryAmounts,
  UiModalContent,
  UiPaymentCard,
  UiLinkCard,
  UserHasDebtsModal,
  AccessToApp,
  RefreshTarifsModal,
  DiscountWorth,
  RemoveDiscount,
  TravelDiscount,
  NoPromoCode,
  UiToast,
  UiMessage,
  CancelPstError,
} from "libs/raas-ui-react-components/src/components";
import useSession from "hooks/useSession";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  _checkBolt,
  _checkFreenow,
  addAproxText,
  getPaymentGatewayData,
  priceStringToNumber,
} from "../ResumeRoute/ResumeRoute.util";
import { getPromoCodeCall, setBookingsCall } from "../ResumeRoute/ResumeRoute.service";
import { formatPrice } from "../TripSelector/TripSelector.service";
import { useNavigate } from "react-router-dom";
import useToast from "hooks/useToast";
import { IBodyTripSelected, ICreateResponseData, Leg, OutwardJourney } from "models/TripInterface";
import { defaultCard, deleteCard, getPaymentMethods, setNavigate } from "services/api/redsys.service";
import { IPaymentCardsSection } from "raas-ui-react-components/dist/types/components/pages/private/p-payment-methods/p-payment-methods.model";
import { getDeleteCardErrorLiterals, getDeleteCardLiterals, getGoogleApple, mapPaymentCards, typePay } from "../PaymentMethods/PaymentMethods.util";
import "../ResumeRoute/ResumeRoute.scss";
import {
  DataPromoCode,
  ETransportLiterals,
} from "../ResumeRoute/ResumeRoute.model";
import { getUserData } from "services/user/user-micros.service";
import { IUserData, setTripSummaryDetail, setUserDetail,setReturnTripSummaryDetail,setTypeSelectedTrip, setSaveTabs, getSaveTabs, setOffSite, initOffSite, setDataCodePromoSession, initDataCodePromo, setPayCit, SessionStorageItems, setPolicy, getPolicy, getUserDetail } from "services/user/user.session.service";
import { dataLayerBeginCheckout, dataLayerPurchase, mappingScreenNameAnalytics } from "services/util/dataLayerAnalytics";
import { pricesConverter } from "../AveFlow/AveFlow.util";
import { getDiscountListCall } from "../MyPoints/MyPoints.service";
import { getTransportDiscounts, getTypeTripAndPst } from "services/util/discount.service";
import { getPrivatePolicyLiterals,getFooterLiterals,getPageLiterals,getUserHasDebtsModalLiterals, getCheckTimeoutTaxiLiterals, getPaymentMethodModalLiterals, getDiscountWorthLiterals, getDiscountNoAppliedLiterals, getRemoveDiscountLiterals, getDiscountCardLiterals, getChangePaymentMethod, getMessageExpiredModal, getUpdatedTarifModalLiterals, getErrorPointsLiterals, getModalErrorDiscountLiterals, getModalErrorMethodPaymentLiterals, getModalErrorPoliciestLiterals, getRouteDiscountLiterals, getProvisionCardLiterals, getLiteralTripInformative, getInfoBoltLiterals, getDontPayGoogleApple } from "../ResumeRoute/ResumenRoute.literals";
import { calculoDescuentoPorRuta, checkIsPost, getIdPricePst, getPstByIdLeg, isRoundTrip, setApplyDiscount, setDeleteDiscount, updatePriceButtons } from "../ResumeRoute/ResumenRouteDiscounts";
import { setBookingsCITCall } from "./ResumeRouteMono.service";
import { getProvisionCardCall } from "../ResumeRouteMulti/ResumeRouteMulti.service";
import { multimodalCardMapping } from "../ResumeRouteMulti/ResumeRouteMulti.util";
import { checkIsRoundTrip, monoModalCardMapping } from "./ResumeRouteMono.util";
import { removeItemStorage } from "services/util/sessionStorage.service";
import { getPaymentMethodsUser, setPaymentMethodsLocal } from "services/user/user.local.service";


declare const window: any;
export const ResumeRouteMono = () => {
  const [t] = useTranslation("resumeroute");
  const [t2] = useTranslation("paymentMethodsFlow");
  const [t3] = useTranslation("discountModals")
  const { openToast } = useToast();
  const { tripSelectedDetails, tripReturnSelectedDetails, fleetKarhooName, typeTrip,setUserConnected,setTripSelectedDetails,setReturnTripSelectedDetails,setTypeTrip } = useSession();
  

  const provisionCardLiterals = getProvisionCardLiterals(t);
  const navigate = useNavigate();
  const privacyPolicyLiterals = getPrivatePolicyLiterals(t);
  const footerLiterals = getFooterLiterals(t);
  const pageLiterals = getPageLiterals(t);
  const userHasDebtsModalLiterals = getUserHasDebtsModalLiterals(t);
  const checkTimeoutTaxiModalLiterals = getCheckTimeoutTaxiLiterals(t);
  const paymentMethodModalLiterals = getPaymentMethodModalLiterals(t);

  //Función literales modales descuento
  const discountWorthLiterals = getDiscountWorthLiterals(t3);
  const discountNoAppliedLiterals=getDiscountNoAppliedLiterals(t3);
  const removeDiscount = getRemoveDiscountLiterals(t3);
  const literalesModalsPoints = getErrorPointsLiterals(t3);
  
  const discountCardLiterals = getDiscountCardLiterals(t3)
  const literalTripInformative = getLiteralTripInformative(t)

  const [travelData, setTravelData] = useState({} as IBodyTripSelected);
  const [openSummaryAmounts, setOpenSummaryAmounts] = useState(false);
  const [showPrivacyPolicy, setshowPrivacyPolicy] = useState(false);
  const [showErrorPrivacyPolicy, setShowErrorPrivacyPolicy] = useState(false);
  const [showMethodPayment, setShowMethodPayment] = useState(false);
  const [showChangeCreditCard, setShowChangeCreditCard] = useState(false);
  const [privacyPolicyAccepted, setPrivacyPolicyAccepted] = useState(false);
  const [privacyPolicyTransports, setPrivacyPolicyTransports] = useState({
    movitaxi: false,
    reby: false,
    cooltra: false,
    karhoo: false,
    bolt: false,
    renfe: false,
    tier:false,
    freenow: false
  });
  const [totalPrice, setTotalPrice] = useState("0,00 €");
  const [totalPriceToPay, setTotalPriceToPay] = useState("0,00 €");
  const [totalPriceAux, setTotalPriceAux] = useState("0,00 €");
  const [totalPriceToPayAux, setTotalPriceToPayAux] = useState("0,00 €");
  const [summaryInfo, setSummaryInfo] = useState([] as any);

  const [paymentDefault, setPaymentDefault] = useState({} as any);
  const [paymentDefaultAux, setPaymentDefaultAux] = useState({} as any);
  const [paymentMethods, setPaymentMethods] = useState([] as any);
  const [cards, setCards] = useState(getGoogleApple(t2,getPaymentMethodsUser()?.id) as any);
  const [cardNumber, setCardNumber] = useState("" as any);
  const [cardType, setCardType] = useState("" as any);
  const [cardExpireDate, setCardExpireDate] = useState("");
  const [isDefaultCardExpired, setIsDefaultCardExpired] = useState(false);
  const [showPayment, setShowPayment] = useState(true);
  const [showTyC, setShowTyC] = useState(true);
  const [showPaymentLiteral, setShowPaymentLiteral] = useState(true);
  const [disableButtonPay, setDisableButtonPay] = useState(false);

  const [showUserHasDebtsModal, setShowUserHasDebtsModal,] = useState(false);
  const [showUpdateTarifModal, setShowUpdateTarifModal] = useState(false);
  const [showCheckTimeoutModal, setShowCheckTimeoutModal] = useState(false);

  const [typeTripDataLayer, setTypeTripDataLayer] = useState("");
  const [showPromo, setShowPromo] = useState(false);
  const [dataCodePromo, setDataCodePromo] = useState({ voucherCode: '',voucherAmount:0, discountType: 'DOCO', isValid: false, reset:false });
  const [totalSumAux, setTotalSumAux] = useState(0);
  const [showModalRouteDiscount, setShowModalRouteDiscount] = useState(false);


  const [routeDiscountLiterals, setRouteDiscountLiterals] = useState({}as any);
  const [transportsDocoDiscountIda, setTransportsDocoDiscountIda] = useState([] as any);
  const [transportsDocoDiscountVuelta, setTransportsDocoDiscountVuelta] = useState([] as any);

  //const [priceDiscount, setPriceDiscount] = useState(0 as number);
  let priceDiscount=0
  const [nameDiscount, setNameDiscount] = useState('' as String);

  const [showModalMajorDiscount , setShowModalMajorDiscount] = useState(false)
  const [isPostDiscount , setIsPostDiscount] = useState(false)
//let isPostDiscount=false;
  const [isMoreDiscountRoutes , setIsMoreDiscountRoutes] = useState(false)

  const [idLegAux , setIdLegAux] = useState(null)
  //const [idLeg , setIdLeg] = useState(0 as any)
  let idLeg=null as any;
  let discount={type:"DOCO_DISCOUNT_CODE",value: '',amount:0}
  const [showModalErrorDiscount, setShowModalErrorDiscount] = useState(false)
  const modalErrorDiscountLiterals = getModalErrorDiscountLiterals(t);
  const modalErrorMethodPaymentLiterals = getModalErrorMethodPaymentLiterals(t);
  const modalErrorPoliciesLiterals = getModalErrorPoliciestLiterals(t);
  const modalChangePaymentMethod = getChangePaymentMethod(t);
  const [isApplyDiscount , setIsApplyDiscount] = useState(false)
  const [showModalDiscountNoApplied , setShowModalDiscountNoApplied] = useState(false)
  const [discountsList, setDiscountsList] = useState([]);
  const [showMessageExpireDateCard, setShowMessageExpireDateCard] = useState(false);
  const [showExpiredCardModal, setShowExpiredCardModal] = useState(false);

  const [currentStep, setCurrentStep] = useState(0);
  const [saveSelectedPst, setSaveSelectedPst] = useState(null as any); //se guarda el id del pst del filter transportsDocoDiscountIda y transportsDocoDiscountVuelta 
  //const [saveTabs, setSaveTabs] = useState(null as any);
  //let saveTabs=null as any
  const [showModalClearDiscounts, setShowModalClearDiscounts] = useState(false);
  const [codeInputDiscount, setCodeInputDiscount] = useState(null);
  const [isOnePst, setIsOnePst] = useState(false);
  const [isRoundTripAux, setIsRoundTripAux] = useState(false);
  let deleteDiscount=false;

  const [copiedDiscountCode, setCopiedDiscountCode] = useState(false)
  const [isCheckServicePoints, setIsCheckServicePoints] = useState(true)
  const [isBolt, setIsBolt] = useState(false)
  const [isFreenow, setIsFreenow] = useState(false)
  const [showModalProvisionCard , setShowModalProvisionCard] = useState(false)
  const [supplyCardPrice, setSupplyCardPrice] = useState("0€")
  const [isInformative, setIsInformative] = useState(false as boolean)
  const [showModaInfoBolt, setShowModaInfoBolt] = useState(false);
  const infoBoltLiterals = getInfoBoltLiterals(t);
  const getOffSide = initOffSite();
  const getDataCodePromo = initDataCodePromo();

  const [policiesAreAccepted, setPoliciesAreAccepted] = useState([] as any)
  const [showNoPayXModal, setShowNoPayXModal] = useState(false);
  const [showDeleteCard, setShowDeleteCard] = useState(false);
  const [cardToDelete, setCardToDelete] = useState({} as any);
  const [showDeleteCardError, setShowDeleteCardError] = useState(false);

  
  //const [typeTrip, setTypeTrip] = useState('departure' as String);


  useEffect(() => {
    _getPayments();
    _calculateSum();
    _calculateSumToPay();
    _concatSummaryInfoArray();
    _setTripBody();
    _getTransportsInfo();
    _hidePayment();
    _getDiscountsList();
    setIsBolt(_checkBolt(tripSelectedDetails,tripReturnSelectedDetails))
    setIsFreenow(_checkFreenow(tripSelectedDetails,tripReturnSelectedDetails))


  }, []);

  /**
   * Para actaualizar el json que se envia al back con el descuento
   */
  useEffect(() => {
    _setTripBody();
  }, [tripSelectedDetails,tripReturnSelectedDetails]);

  //Si cambia de idioma comprueba de nuevo los literales de los precios
  useEffect(() => {
    _calculateSumToPay()
  }, [t]);

  useEffect(() => {
    //deleteDocoDiscountDesglose();
    if(getOffSide===false){
      deleteDocoDiscountDesglose();
    }else{
      if(getDataCodePromo?.isValid===true){
        setIsApplyDiscount(true)
        setDataCodePromo(getDataCodePromo)
        setTotalPrice(getDataCodePromo.totalPrice)
        setTotalPriceToPay(getDataCodePromo.totalPriceToPay)
      }


    }

 
  }, [deleteDiscount]);
  

  useEffect(() => {
    let typeTrip = "";
    if(summaryInfo){
    if (summaryInfo.length === 0 || summaryInfo.length === 1 ) {
      typeTrip = "oneway";
   
    } else {
      typeTrip = "round";
    }
  }

    dataLayerBeginCheckout(tripSelectedDetails, totalPrice, summaryInfo, travelData,typeTrip)
  }, [summaryInfo]);


  useEffect(() => {
    let typeTrip = "";
    if(summaryInfo){
    if (summaryInfo.length === 0 || summaryInfo.length === 1 ) {
      typeTrip = "oneway";
   
    } else {
      typeTrip = "round";
    }
    setTypeTripDataLayer(typeTrip)
    window.dataLayer?.push({
      event: "page_view",
      screen_name: typeTrip,
      screen_class: "trip_cart_resume"
    });
  }
  }, [!summaryInfo]);


  useEffect(() => {
    let typeTrip = "";
    if(summaryInfo){
    if (summaryInfo.length === 0 || summaryInfo.length === 1 ) {
      typeTrip = "oneway";
   
    } else {
      typeTrip = "round";
    }
  }

    dataLayerBeginCheckout(tripSelectedDetails, totalPrice, summaryInfo, travelData,typeTrip)
  }, [policiesAreAccepted]);

   // useEffect que se ejecuta cuando policiesAreAccepted se modifica
   useEffect(() => {
    setPolicy({
      father:privacyPolicyAccepted,
    })
  }, [privacyPolicyAccepted]); // Dependencia: se ejecuta cuando policiesAreAccepted cambia


  const _hidePayment = () => {
    // Inicializamos el contador
    let countIda = 0;
    let countVuelta = 0;
  
    // Extraemos los arrays de transportes, asegurando que no sean undefined
    const arrayIda = tripSelectedDetails?.summaryAmount?.departure?.transports || [];
    const arrayVuelta = tripReturnSelectedDetails?.summaryAmount?.arrival?.transports || [];
  
    // Contamos los transportes urbanos en el array de ida
    arrayIda.forEach((element: any) => {
      if (
        element.transport === ETransportLiterals.busUrb ||
        element.transport === ETransportLiterals.metro ||
        (element.details && element.details[0]?.external === true)
      ) {
        countIda++;
      }
    });
  
    // Contamos los transportes urbanos en el array de vuelta
    arrayVuelta.forEach((element: any) => {
      if (
        element.transport === ETransportLiterals.busUrb ||
        element.transport === ETransportLiterals.metro||
        (element.details && element.details[0]?.external === true)
      ) {
        countVuelta++;
      }
    });
  
    // Verificamos si todos los transportes en arrayIda son urbanos
    const allIdaUrban = countIda === arrayIda.length && arrayIda.length > 0;
    
    // Verificamos si todos los transportes en arrayVuelta son urbanos
    const allVueltaUrban = countVuelta === arrayVuelta.length && arrayVuelta.length >= 0;
  
    // Comprobamos que ambos arrays son urbanos y que el precio total es "0,00 €"
    if (allIdaUrban && allVueltaUrban && totalPrice === "0,00 €") {
      setShowPayment(false);
      setShowTyC(false);
      setPrivacyPolicyAccepted(true);
    }
  };
  

  useEffect(() => {
    let cardType=""
    let cardNumberAux = paymentDefault.number;
    //let cardTypeAux = paymentDefault?.type?.toLowerCase();

    let cardExpireDateAux = paymentDefault.expireDate;
    if(paymentDefault?.icon==="google_pay" ||paymentDefault?.icon==="apple_pay" ){
      cardType=paymentDefault?.icon
    }else{
      cardType = paymentDefault?.type?.toLowerCase();
    }
    setCardNumber(cardNumberAux);
    setCardType(cardType);
    setCardExpireDate(cardExpireDateAux);
  
  }, [paymentDefault]);

  /* Comprueba siempre el status de los precios y deshabilita el botón si no cumple. */
  useEffect(() => {
    checkDisabledButtonPay();
    checkDisabledPromo();
  }, [showPayment, paymentMethods])


  const _getPayments = () => {
    getPaymentMethods().then((response: any) => {
      const paymentDefaultMethod = mapPaymentCards(response, t2, true,getPaymentMethodsUser()?.id).filter((t: any) => t.default===true)[0]

      setPaymentDefault({ ...paymentDefaultMethod });
      setPaymentMethods(mapPaymentCards(response, t2, false,getPaymentMethodsUser()?.id));
      setCards(mapPaymentCards(response, t2, false,getPaymentMethodsUser()?.id))
   
      if(paymentDefaultMethod && isExpiredDatePaymentCard(paymentDefaultMethod.expireDate)){
        setIsDefaultCardExpired(true);
        setShowExpiredCardModal(true);
      }

    })
  }

  const _getDiscountsList = () => {
  
    getDiscountListCall(
      (response: any) => {
        if(response.length!=0){
          setDiscountsList(response);
        }else{
          setDiscountsList([]);
        }
  
        setIsCheckServicePoints(false)
      },
      (err: any) => {
        setIsCheckServicePoints(true)
        if (!err.status) {
          console.warn("Ha ocurrido un error", err);
        }
        if (err && err.status !== 401) {
          // openToast("error", t("literals.errorRequest"), `${err?.status ? ':' + err?.status : ''} ${err?.statusText}`)
        } else if (err && err[0] && err[0].code) {
          // openToast("error", t("literals.errorRequest"), `${err[0].code ? ':' + err[0].code : ''} ${err[0].message}`)
        }
      },
      window.sessionStorage["raas-trip-mock"]
    );
  };

  const _calculateSum = () => {
    const departureSummary = tripSelectedDetails?.summary;
    const departureSum = (departureSummary || []).reduce(
      (accumulator, object: any) => {
        return accumulator + object.priceNumber;
      },
      0
    );
    const returnSummary = tripReturnSelectedDetails?.summary;

    const arrivalSum = (returnSummary || []).reduce(
      (accumulator, object: any) => {
        return accumulator + object.priceNumber;
      },
      0
    );
    const totalSum = departureSum + arrivalSum;
    const totalString = `${formatPrice(totalSum)} €`;
    if (_checkThereIsFreenowInBody() || _checkThereIsTierCooltraInBody() ||_checkThereIsTierInBody()|| _checkThereIsBolt()) {
      setTotalPrice(t("approx") + totalString);
      setTotalPriceToPayAux(totalString)
    } else {
      setTotalPrice(totalString);
      setTotalPriceToPayAux(totalString)
    }
  };

  const _calculateSumToPay = () => {
    let departureSum =
      tripSelectedDetails?.summaryAmount?.departure?.desglose?.now || "0";
    departureSum = departureSum?.split("€")[0];
    departureSum = departureSum?.split(",").join(".");
    let arrivalSum =
      tripReturnSelectedDetails?.summaryAmount?.arrival?.desglose?.now || "0";
    arrivalSum = arrivalSum?.split("€")[0];
    arrivalSum = arrivalSum?.split(",").join(".");
    
  
    const totalSum = parseFloat(departureSum) + parseFloat(arrivalSum);
    setTotalSumAux(totalSum)
    const totalString = `${formatPrice(totalSum)} €`;

    if (totalSum === 0 && (!_checkThereIsTierInBody()&& !_checkThereIsTierCooltraInBody() && !_checkThereIsFreenowInBody() && !_checkThereIsBolt())) {
      setShowPayment(false);
      setPrivacyPolicyAccepted(true);
      setTotalPriceAux(t("saveToMyTrips"))
      setTotalPriceToPay(t("saveToMyTrips"));
      setShowPaymentLiteral(false);
      setShowTyC(false)
    } else if (totalSum === 0 && _checkThereIsTierCooltraInBody()) {
      setShowPayment(false);
      setPrivacyPolicyAccepted(false);
      setTotalPriceAux(t("addMoto"))
      setTotalPriceToPay(t("addMoto"));
      setShowPaymentLiteral(false);
      setShowTyC(true)
    }
    else if (totalSum === 0 && _checkThereIsTierInBody()) {
      setShowPayment(false);
      setPrivacyPolicyAccepted(false);
      setTotalPriceAux(t("addTier"))
      setTotalPriceToPay(t("addTier"));
      setShowPaymentLiteral(false);
      setShowTyC(true)
    }

    else if (totalSum === 0 && _checkThereIsFreenowInBody()) {
      setShowPayment(true);
      setPrivacyPolicyAccepted(false);
      setTotalPriceAux(t("saveNow"))
      setTotalPriceToPay(t("saveNow"));
      setShowPaymentLiteral(false);
      setShowTyC(true)
    }
    else if (totalSum === 0 && _checkThereIsBolt()) {
      setShowPayment(true);
      setPrivacyPolicyAccepted(false);
      setTotalPriceAux(t("saveNow"))
      setTotalPriceToPay(t("saveNow"));
      setShowPaymentLiteral(false);
      setShowTyC(true)
    }
    else {
      setShowPaymentLiteral(true);
      setTotalPriceAux(totalString)
      setTotalPriceToPay(totalString);
    }
  };

  const _concatSummaryInfoArray = () => {
    const outwardBody = tripSelectedDetails?.body;
    const returnBody = tripReturnSelectedDetails?.body;
    const outwardTransport = tripSelectedDetails?.summaryAmount?.departure?.transports;
    const returnBodyTransport = tripReturnSelectedDetails?.summaryAmount?.arrival?.transports;
    const isRoundTrip=checkIsRoundTrip(outwardTransport,returnBodyTransport)
    const transportPospago = _checkThereIsTierInBody(outwardBody)|| _checkThereIsTierCooltraInBody(outwardBody) || _checkThereIsFreenowInBody(outwardBody) || _checkThereIsBolt();
    if (transportPospago) {
      tripSelectedDetails.summary[0].price = addAproxText(tripSelectedDetails.summary[0].price, t);
    }

    if (!!returnBody) {
      const transportPospago = _checkThereIsTierInBody(returnBody)|| _checkThereIsTierCooltraInBody(returnBody) || _checkThereIsFreenowInBody(returnBody) || _checkThereIsBolt();
      if (transportPospago) {
        tripReturnSelectedDetails.summary[0].price = addAproxText(tripReturnSelectedDetails.summary[0].price, t);
      }
    }

    const  resultDeparture =monoModalCardMapping(outwardTransport,t,"departure",isRoundTrip)
    const resultArrival= monoModalCardMapping(returnBodyTransport,t,"arrival",isRoundTrip) 
      const concatSummaryArray = (resultArrival)
      ? resultDeparture.concat(resultArrival) 
      : resultDeparture;

    setSummaryInfo(concatSummaryArray);
    if(concatSummaryArray.length===0){
      //es informativo todo el viaje
      setIsInformative(true);
      setPrivacyPolicyAccepted(true)
      setShowPromo(false)
    }

  };

  const _checkThereIsBolt = () => {
    const outwardtrip = !!tripSelectedDetails?.body?.outwardJourney?.trip?.LegList?.Leg?.find(
      (el: any) => el.name === "Bolt"
    );
    const returntrip = !!tripReturnSelectedDetails?.body?.outwardJourney?.trip?.LegList?.Leg?.find(
      (el: any) => el.name === "Bolt"
    );
    return outwardtrip || returntrip;
  }

  const _checkThereIsFreenowInBody = (body?: any) => {
    if (body) {
      let prop = body?.returnJourney ? "returnJourney" : "outwardJourney";
      return body?.[prop]?.trip?.LegList?.Leg?.find((el: any) => el.name === "Freenow" /*|| el.name == "cooltra" || el.name == "Reby eScooter"*/)
        ? true
        : false;
    } else {
      return tripSelectedDetails?.body?.outwardJourney?.trip?.LegList.Leg.find(
        (el: any) => el.name === "Freenow" /*|| el.name === "Movitaxi"*/ /*|| el.name == "cooltra" || el.name == "Reby eScooter"*/
      )
        ? true
        : false;
    }
  };

  const _checkThereIsTierCooltraInBody = (body?: any) => {
    if (body) {
      let prop = body?.returnJourney ? "returnJourney" : "outwardJourney";
      return body?.[prop]?.trip?.LegList?.Leg?.find((el: any) => el.name == "cooltra")
        ? true
        : false;
    } else {
      return tripSelectedDetails?.body?.outwardJourney?.trip?.LegList?.Leg?.find(
        (el: any) => el.name === "cooltra"
      )
        ? true
        : false;
    }
  };

  const _checkThereIsTierInBody = (body?: any) => {
    if (body) {
      let prop = body?.returnJourney ? "returnJourney" : "outwardJourney";
      return body?.[prop]?.trip?.LegList?.Leg?.find((el: any) =>  el.name == "TIER")
        ? true
        : false;
    } else {
      return tripSelectedDetails?.body?.outwardJourney?.trip?.LegList?.Leg?.find(
        (el: any) =>  el.name === "TIER"
      )
        ? true
        : false;
    }
  };


  const _getTransportsInfo = () => {
    const { departure } = tripSelectedDetails.summaryAmount;
    const arrival = tripReturnSelectedDetails?.summaryAmount?.arrival;

    const transports = [
      ...(departure?.transports ? departure.transports : []),
      ...(arrival?.transports ? arrival.transports : []),
    ];
    const auxTransports = { ...privacyPolicyTransports };

    transports.forEach(item => {
      switch (item.transport) {
        case ETransportLiterals.taxi:
          auxTransports.movitaxi = true;
          break;
        case ETransportLiterals.reby:
          auxTransports.reby = true;
          break;
        case ETransportLiterals.cooltra:
          auxTransports.cooltra = true;
          break;
        case ETransportLiterals.karhoo:
          auxTransports.karhoo = true;
          break;
        case ETransportLiterals.bolt:
          auxTransports.bolt = true;
          break;
        case ETransportLiterals.cercanias:
          auxTransports.renfe = true;
          break;
        case ETransportLiterals.renfe:
        case ETransportLiterals.ave:
          auxTransports.renfe = true;
          break;
        case ETransportLiterals.avant:
          auxTransports.renfe = true;
          break;
        case ETransportLiterals.tier:
            auxTransports.tier = true;
        break;
        case ETransportLiterals.freenow:
            auxTransports.freenow = true;
        break;
      }
    });
    setPrivacyPolicyTransports({ ...auxTransports });
  };

  const deleteGisRoute = (outwardJourney: OutwardJourney): any => {
    return {
      ...outwardJourney,
      trip: {
        ...outwardJourney.trip,
        LegList: {
          ...outwardJourney.trip?.LegList,
          Leg: outwardJourney.trip?.LegList?.Leg?.map((leg: Leg) => {
            return {
              ...leg,
              GisRoute: undefined
            }
          })
        }
      }
    }
  }

  const _setTripBody = () => {
    const { outwardJourney: outward, travellers } = tripSelectedDetails?.body;

    /* DOCO-267: Delete Trip.GisRoute */
    const outwardJourney = deleteGisRoute(outward as OutwardJourney);

    const returnJourney = tripReturnSelectedDetails?.body
      ? tripReturnSelectedDetails?.body?.returnJourney
      : {};
    const body = tripReturnSelectedDetails?.body
      ? { outwardJourney, travellers, returnJourney }
      : { outwardJourney, travellers };

   
    setTravelData(body as IBodyTripSelected);
    
  }

  const nextPage = () => {
    if(disableButtonPay===true){
      setShowMethodPayment(true)
    }else{
      if(isInformative===true){
        _getMyProfileInfo()
      }else{

    if (getPolicy().father === false ||getPolicy().father===undefined ) {
      if(privacyPolicyAccepted){
        _getMyProfileInfo()
      }else{
        setShowErrorPrivacyPolicy(true)
        //setshowPrivacyPolicy(true)
      }

    }else{
      _getMyProfileInfo()
    }
    }
    }
    //privacyPolicyAccepted ? _getMyProfileInfo() : setshowPrivacyPolicy(true);
  };

  const handleCreditCardChange = () => {
    setShowChangeCreditCard(true);
  };

  const handleAddCreditCard = () => {   
        setOffSite(true)
        setDataCodePromoSession({...dataCodePromo,totalPrice:totalPrice,totalPriceToPay:totalPriceToPay})
        setNavigate("/app/resume-route");
        navigate(`/redsys:addCard?goTo=/app/resume-route`);    
  };

  const handleGoMyPoints = () => {   
    setNavigate("/app/resume-route");
    navigate(`/my-points?goTo=/app/resume-route`);    
  }

  const isExpiredDatePaymentCard = (expiredDate: string) => {
		const currentDate = new Date();
		const expireDate = new Date(expiredDate);

		return expireDate < currentDate;
  };

  const handleSelectCard = () => {
    let selectedCard = cards.find((card: any) => card.selected);
  
    if (selectedCard && isExpiredDatePaymentCard(selectedCard.expireDate)) {
      setIsDefaultCardExpired(true);
      setShowMessageExpireDateCard(true);
      return;
    }

    if ((selectedCard.id !== paymentDefault.id) && selectedCard.number!==typePay.GOOGLE && selectedCard.number!==typePay.APPLE  &&selectedCard.number!==typePay.XPAY  ) {
      const id = selectedCard.id;
      const body = {
        defaultPaymentMethod: "true",
      };
      defaultCard(id, body)
        .then((response: any) => {
          window.sessionStorage.removeItem('raas-payment-methods');
 
        })
        .catch((error: any) => {
          openToast("error", t("literals.title"), t("literals.errorSaving"));
        });
    }else{
          let valueUserDetail = getUserDetail().email;

              setPaymentMethodsLocal({
                id:selectedCard.id,
                email:valueUserDetail
              })

    
    }
    setIsDefaultCardExpired(false);
    setPaymentDefault(paymentDefaultAux);
    setShowChangeCreditCard(false);
  };
  

  const handleUpdateModal = () => {
    setShowUpdateTarifModal(false);
    navigate(sessionStorage.getItem("raas-url") || "/plan");
  }

  const handleClickCard = (ev: CustomEvent) => {
    setShowMessageExpireDateCard(false);
    let id = ev.detail;
    let aux: any[] = [];
    cards.forEach((el: IPaymentCardsSection) => {
      if (el.id == id) {
        el.selected = true;
        setPaymentDefaultAux(el);
      } else {
        el.selected = false;
      }
      aux.push(el);
    });
    setCards([...aux]);
  };

  const _createTrip = () => {
    // Antes de crear el trip hay que revisar las tarifas RAASWEB-708
    const outwardTransport = tripSelectedDetails?.summaryAmount?.departure?.transports;
    const returnBodyTransport = tripReturnSelectedDetails?.summaryAmount?.arrival?.transports;
    checkTarifsAreAvailable(() => {
      let paymentID = paymentDefault?.id || "";
      let body = {
        ...travelData,
        paymentMethodId: showPayment && ( paymentID===typePay.GOOGLE || paymentID===typePay.APPLE || paymentID===typePay.XPAY) ?  "":paymentID  ,
        payReturn: checkIsRoundTrip(outwardTransport,returnBodyTransport),
        indexToPay: 0,
        ...(paymentID===typePay.GOOGLE || paymentID===typePay.APPLE || paymentID===typePay.XPAY ? {paymentMethod:paymentID}:{paymentMethod:typePay.CREDIT})//Provisional enviamos apple hasta que siemnes nos de el dato correcto
      };
      sessionStorage.setItem('body-booking', JSON.stringify(body));
      setBookingsCITCall(
        body,
        (response: ICreateResponseData) => {
          //Levantamos la pasadela de pago
          if(response.data.redirect){
            const {url,Ds_SignatureVersion,Ds_Signature,Ds_MerchantParameters}=getPaymentGatewayData(response)
            setPayCit({
              url:url,
              Ds_SignatureVersion:Ds_SignatureVersion,
              Ds_Signature:Ds_Signature,
              Ds_MerchantParameters:Ds_MerchantParameters
            })
  
            if(isBolt || isFreenow){
              let price=response.data?.items[0]?.tickets[0]?.price?.reservationAmount
              setSupplyCardPrice((`${formatPrice(price/100)}€`))
              setShowModalProvisionCard(true);
            }else{
              navigate(`/redsys:payCit`);
            }
          }else{
            navigate("/confirm-planing");
          }
        

          //dataLayerBeginCheckout(tripSelectedDetails,totolPrice,summaryInfo,travelData)
          try {
            dataLayerBeginCheckout(tripSelectedDetails,totalPrice,summaryInfo,travelData)
            dataLayerPurchase(tripSelectedDetails, totalPrice, summaryInfo, travelData, response,typeTripDataLayer)
          } catch (error) {
            console.error('Fallo en el datalayer')
          }
          //navigate("/confirm-planing");
        },
        (err: any) => {
          const msg = err.data?.errors?.[0]?.message || err?.statusText;
          const isTarifNotAvailable = err?.data?.errors?.[0]?.code?.includes("024");
          const isOrderFail= err?.data?.errors?.[0]?.code?.includes("014");
          if (isTarifNotAvailable) {
            setShowUpdateTarifModal(true);
          } else if(isOrderFail) {
            openToast("error", t2("literals.errorRequest"),t("literals.errorOrderFail") )
          }else{
            openToast("error", t2("literals.errorRequest"), `${err?.status}: ${msg}`)
          }
        }
      )
    })
  }

  const checkTarifsAreAvailable = (callback: Function) => {

    callback();
  }

  const _userWithDebtsFlow = () => {
    setShowUserHasDebtsModal(true);
  }

  const _checkIfIsBoolean = (customerAllowed: string | boolean): boolean => {
    return typeof customerAllowed == "boolean";
  }
  const _getCustomerAllowedStatus = (customerAllowedValue: string | boolean, userDataResponse: IUserData) => {
    return _checkIfIsBoolean(customerAllowedValue) ? customerAllowedValue : userDataResponse?.payment?.customerAllowed === "true";
  }

  //Metodo onClick del boton de pagar
  const _getMyProfileInfo = () => {

      if(!isApplyDiscount && dataCodePromo?.isValid){
        setShowModalDiscountNoApplied(true)
      }else{
        let selectedCard = cards.find((card: any) => card.selected);
        //let isBolt=infoReserve.find((item: any) => item?.line === 'Bolt');
		if (selectedCard &&	isExpiredDatePaymentCard(selectedCard.expireDate)) {
            setIsDefaultCardExpired(true);
			      setShowExpiredCardModal(true);
		} else {
            setIsDefaultCardExpired(false);
    if((isBolt === true || isFreenow === true ) && (selectedCard.id===typePay.APPLE || selectedCard.id===typePay.GOOGLE || selectedCard.id===typePay.XPAY) ){
        //No dejar comprar ya que con google y apple no hay retención
        setShowNoPayXModal(true);
    }else{
        continuePayment();
    }       
      }
    }


  };

  const _checkIfUserHasDebts = (userDataResponse: IUserData): void => {
    const customerAllowedValue = userDataResponse?.payment?.customerAllowed;
    const customerAllowed = !!customerAllowedValue ? _getCustomerAllowedStatus(customerAllowedValue, userDataResponse) : false;
    customerAllowed
      ? _createTrip()
      : _userWithDebtsFlow();
  }


  const backPage = () => {
    const params = new URLSearchParams(window?.location?.search);
    const path = sessionStorage.getItem("raas-url") || '/trip';
    setReturnTripSelectedDetails(null as any);
    removeItemStorage(SessionStorageItems.RAAS_RETURN_TRIP_SUMMARY_DETAIL);
    removeItemStorage(SessionStorageItems.RAAS_ANY_PAID);
    removeItemStorage(SessionStorageItems.RAAS_OFF_SITE);
    navigate(path);
  };


  

  const checkTimeoutTaxi = () => {
    let result = false;
        window.dataLayer?.push({
        event:"page_view",
        screen_name: 'taxi_delay_alert',
        screen_class: mappingScreenNameAnalytics(window.location.pathname),
      });
    const hasTaxi = tripSelectedDetails?.summaryAmount?.departure?.transports?.find((transport: any) => transport.transport === 'Taxi/VTC');
    if (hasTaxi) {
      const dateStart = new Date();
      const dateNowMinutes = new Date();

      let timeOrigin = tripSelectedDetails.body.outwardJourney?.trip?.LegList.Leg.find((transport: any) => transport.type === 'TAXI')
      let dateOrigen = getDateTrip(timeOrigin?.Origin?.date as string);
      const dateNow = new Date().toLocaleDateString('en-GB');
      //Si es el mismo dia el viaje que la fecha actual calculamos minutos
      if (dateOrigen === dateNow) {
        let hours = timeOrigin?.Origin?.time.substring(0, 2);
        let minutes = timeOrigin?.Origin?.time.substring(3, 5);
        const convertHour = parseInt(hours as any, 10)
        const convertMinute = parseInt(minutes as any, 10)


        dateStart.setHours(convertHour);
        dateStart.setMinutes(convertMinute);

        var difference = dateStart.getTime() - dateNowMinutes.getTime();
        var resultInMinutes = Math.round(difference / 60000)

        if (resultInMinutes < 20) {
          return result = true
        }
      }


    }
    return result
  };


  function getDateTrip(date: string) {
    let year = date.substring(0, 4);
    let month = date.substring(5, 7);
    let day = date.substring(8, 10);

    let result = day + "/" + month + "/" + year;
    return result
  };


  //Servicio de pagar
  const continuePayment = () => {
    getUserData((response: any) => {
      const userDataResponse = response?.data;
      setUserDetail(userDataResponse)
      setUserConnected(userDataResponse);
      _checkIfUserHasDebts(userDataResponse);
      // setIsApplyDiscount(true)
    }, () => {
      openToast("error", t("literals.error"), t("literals.errorTryAgainLater"));
    })
  }


  //Metodo al pulsar entendido en el modal de checkTime de taxi
  const okShowCheckTimeoutModal = () => {
    setShowCheckTimeoutModal(false);
    continuePayment();
  }


  const paymentCards = () => {
    return (
      <div className="row">
        {cards?.map((card: IPaymentCardsSection) => {
          return (
            <div key={card.id} className="col-sm-12 card-margin">
              <UiPaymentCard
                onNavigateToEvent={handleClickCard}
                href-link={card.id}
                disabled={false}
                selected={card.selected}
                card-top-text={card.type}
                card-bottom-text={"**** " + card.number}
                icon-left-type={card.icon}
                card-bottom-sub-text={card.expireDate}
                icon-right-type="delete_icon"
                class-type={undefined}
                expired-text={modalChangePaymentMethod.stateCard}
                onRightCardClick={handleDeleteCheck}
              ></UiPaymentCard>
            </div>
          );
        })}
      </div>
    );
  };

  const cardsLinksSection = () => {
    return (
      <div className="row">
        <div className="col-sm-12 card-margin">
          <UiLinkCard
            onNavigateToEvent={handleAddCreditCard}
            href-link={"path"}
            disabled={false}
            card-text={t2("literals.addCreditDebitCard")}
            icon-type={"pay"}
          ></UiLinkCard>
        </div>
      </div>
    );
  };

  const checkDisabledButtonPay = () => {
    /* Que no sea "guardar mis viajes" y se comprueba si se ha añadido tarjeta. */
    if ((!totalPriceToPay.includes(t("saveToMyTrips")))) {
      setDisableButtonPay(showPayment && paymentMethods?.length == 0);
 
    } else {
      setDisableButtonPay(false);
    }
  }


  //////////////// BLOQUE DESCUENTO DOCO////////////////////


  const checkDisabledPromo = () => {
    const transportsIda=tripSelectedDetails?.summaryAmount?.departure?.transports?.find((i: any) => 
      i?.transport && 
      i?.informative === false && 
      i?.bonoAveFree === false && 
      i?.idTariff!=undefined&&
      (i?.isIncluding === false || i?.isIncluding === undefined)
    );
    const transportsVuelta=tripReturnSelectedDetails?.summaryAmount?.arrival?.transports?.find((i: any) => 
      i?.transport && 
      i?.informative === false && 
      i?.bonoAveFree === false && 
      i?.idTariff!=undefined&&
      (i?.isIncluding === false || i?.isIncluding === undefined)
    );
    if(transportsIda!=undefined  || transportsVuelta!=undefined ){
      setShowPromo(true);
    }else{
      setShowPromo(false);
    }

  }
  /**
   * Funcion que comprueba si el codigo es valido 
   * @param value codigo 
   */
  const checkPromoCode = (value:any) => {
   const {transport}=getPstByIdLeg(saveSelectedPst,transportsDocoDiscountIda,transportsDocoDiscountVuelta)
    let body={ 
      voucherCode:value?.voucherCode,
      discountType:"DOCO",
      provider: transport,
      purchaseAmount: saveSelectedPst.priceNumber,
   }
   setCodeInputDiscount(value?.voucherCode)
    getPromoCodeCall(
      body,
      (response: any) => {
        if(response.data.isValid===false){
          setDataCodePromo({ voucherCode: response.data.voucherCode,voucherAmount:response.data.voucherAmount, discountType: response.data.discountType, isValid: false, reset:false });
        }else{
          setDataCodePromo({ voucherCode: response.data.voucherCode,voucherAmount:response.data.voucherAmount, discountType: response.data.discountType, isValid: true, reset:false });
        }

      },
      (err: any) => {
        openToast("error", t("literals.error"),t("literals.errorTryAgainLater"))
      },window.sessionStorage["raas-trip-mock"]
    )
  }

  /**
   * Funcion donde aplica el descuento
   * @param e 
   */
  const applyDocoDiscount = (e: any) => {
    let isPost=false;
 
    setSaveTabs(e)

    //idLeg=null;
    priceDiscount=dataCodePromo.voucherAmount/100;
    setNameDiscount(dataCodePromo.voucherCode);
    let priceDiscountAux=dataCodePromo.voucherAmount/100
    discount={type:"DOCO_DISCOUNT_CODE",value: dataCodePromo.voucherCode,amount:dataCodePromo.voucherAmount}
    setCodeInputDiscount(null)
    //Si tiene un punto es  postPago
    if(transportsDocoDiscountIda){
    if(transportsDocoDiscountIda[0]?.price?.includes('.')){
      isPost=true;
    }
  }

    let { typeSelectedTrip, idLeg, pstPrice } = getIdPricePst(e,transportsDocoDiscountIda,transportsDocoDiscountVuelta,saveSelectedPst);
    setTypeSelectedTrip(typeSelectedTrip)

    const priceTrip = pricesConverter(pstPrice);
    //El descuento es MAYOR mostramos modal de aviso
    if((priceDiscountAux>priceTrip)){
      setShowModalRouteDiscount(false)//cerramos el modal de escribir código
      setShowModalMajorDiscount(true);

     }else{
      //Cuando es IDA
      if(e.tabs==="tab1"){
        applyDiscountMoreRoute(idLeg,transportsDocoDiscountIda)
      }else{
       //Cuando es VUELTA 
       applyDiscountMoreRoute(idLeg,transportsDocoDiscountVuelta)
      }
    }
     

   
}

  /**
   * Funciona que borrar el desglose motivo por renderizado
   */
  const deleteDocoDiscountDesglose = () => {
    if(typeTrip){
      setNameDiscount('')
    if (typeTrip.type==="departure"){
      let result= setDeleteDiscount(tripSelectedDetails,typeTrip.type);
      // Actualizamos las variable que tiene el viaje
      setTripSummaryDetail(result as any)
      setTripSelectedDetails(result as any)
    }else if(typeTrip.type==="arrival"){
      let result= setDeleteDiscount(tripReturnSelectedDetails,typeTrip.type);
      // Actualizamos las variable que tiene el viaje
      setReturnTripSelectedDetails(result as any)
      setReturnTripSummaryDetail(result as any)

    }
  }
  
  }

  /**
   * Funcion donde quitamos el descuento
   * @param e 
   */
  const deleteDocoDiscount = (e?: DataPromoCode) => {
      //Funcion donde eliminamos el objeto del descuento
      setOffSite(false)
      setIsApplyDiscount(false)
      if(typeTrip){
      if (typeTrip.type==="departure"){
        let result= setDeleteDiscount(tripSelectedDetails,typeTrip.type);
        // Actualizamos las variable que tiene el viaje
        setTripSummaryDetail(result as any)
        setTripSelectedDetails(result as any)
      }else if(typeTrip.type==="arrival"){
        let result= setDeleteDiscount(tripReturnSelectedDetails,typeTrip.type);
        // Actualizamos las variable que tiene el viaje
        setReturnTripSelectedDetails(result as any)
        setReturnTripSummaryDetail(result as any)
      }
    }
    setDataCodePromo({ voucherCode: '',voucherAmount:0, discountType: 'DOCO', isValid: false, reset:false });
      //Precio total del viaje
      checkTotalPrice(totalPriceToPayAux)
      //Precio boton
      setTotalPriceToPay(totalPriceAux);

  }



/**
 * Funcion para aplicar el descuento cuando sea mayor , mediante el modal de aviso
 */
const applyDiscountMajor = () => {

  priceDiscount=dataCodePromo.voucherAmount/100;
  let idLeg
  if(getSaveTabs().tabs==="tab1"){
    if(getSaveTabs().travelSelected!=undefined){
      idLeg=transportsDocoDiscountIda[getSaveTabs().travelSelected].idLeg
    }else{
      idLeg=saveSelectedPst?.idLeg as any
    }
    applyDiscountMoreRoute(idLeg,transportsDocoDiscountIda)
  }else{
   //Cuando es VUELTA 
   if(getSaveTabs().travelSelected!=undefined){
    idLeg=transportsDocoDiscountVuelta[getSaveTabs().travelSelected].idLeg
  }else{
    idLeg=saveSelectedPst?.idLeg as any
  }

   applyDiscountMoreRoute(idLeg,transportsDocoDiscountVuelta)
  }


}

/**
 * Funcion para aplciar descuento cuando hay mas de una ruta y si es ida y vuelta
 */
const applyDiscountMoreRoute=(idLeg:number,transports:any)=>{
  //let getPriceButton=priceStringToNumber(totalPriceAux===t("saveToMyTrips") ?"0,00" : totalPriceAux)
  let getPriceButton
  if(totalPriceAux===t("saveToMyTrips")){
    getPriceButton=priceStringToNumber("0,00")
  }else if(totalPriceAux===t("saveNow")){
    getPriceButton=priceStringToNumber(totalPriceToPayAux)
  }
  else{
    getPriceButton=priceStringToNumber(totalPriceAux)
  }
  let getPriceTotal=priceStringToNumber(totalPriceToPayAux)
  const {getTotal,bodyPost,type,filter}=getTypeTripAndPst(tripSelectedDetails,tripReturnSelectedDetails,getSaveTabs()?.key,transports,idLeg)
  setTypeTrip(type)

  let totalTrip

  let discountToApply=0;
  let { getPriceTrip,routeSelectPrice,isPost} = checkIsPost(filter);

  
  discountToApply=calculoDescuentoPorRuta(getPriceTrip,priceDiscount) //+ priceStringToNumber(getReturn) as any
  let isIdaVuelta= isRoundTrip(transportsDocoDiscountIda,transportsDocoDiscountVuelta)
  let { priceTotal,priceButton,totalIdaVuelta} = updatePriceButtons(discountToApply,getPriceTotal,getPriceButton,routeSelectPrice,priceDiscount,isPost, getTotal,isIdaVuelta);

 if(!isIdaVuelta){
   totalTrip=priceTotal
 }else{
  totalTrip=totalIdaVuelta
 }
  getPriceTotal=priceTotal;
  getPriceButton=priceButton;
  //Funcion donde añadimos el objeto del descuento desglose

  let result= setApplyDiscount(bodyPost,priceDiscount,dataCodePromo.voucherCode,isPost,filter.key,filter.idTariff,totalTrip,t,dataCodePromo.discountType,isRoundTripAux);
  setIsApplyDiscount(true);

  if(filter.key==="departure"){
    setTripSummaryDetail(result as any)
    setTripSelectedDetails(result as any)
  }else{
    setReturnTripSelectedDetails(result as any)
    setReturnTripSummaryDetail(result as any)
  }

  //Total se suma todo
  //checkTotalPrice(getPriceTotal)

  //Tota de lo que voy a pagar ahora
  //checkTripPayment(getPriceButton);
  setShowModalMajorDiscount(false) //????
  setShowModalRouteDiscount(false)
}


const checkTotalPrice =(resultadoTotal: any)=>{
  if (_checkThereIsFreenowInBody() || _checkThereIsTierCooltraInBody() || _checkThereIsBolt()) {
    if(!isNaN(resultadoTotal)){
    let datoParametro=`${resultadoTotal}`;
    let dato=datoParametro.replace(".",",");
    setTotalPrice(t("approx") +`${dato} €`);
    }else{
 
    if(resultadoTotal.includes("€")){
      setTotalPrice(t("approx") +`${resultadoTotal}`);
    }else{
      setTotalPrice(t("approx") +`${resultadoTotal} €`);
    }
  }
  } else {
    if(!isNaN(resultadoTotal)){
 
      setTotalPrice(`${formatPrice(resultadoTotal)} €`);
    
    
    }else{
      if(resultadoTotal.includes("€")){
        setTotalPrice(resultadoTotal);
      }else{
        setTotalPrice(`${formatPrice(resultadoTotal)} €`);
      }
    }
  
    //setTotolPrice(`${formatPrice(resultadoTotal)} €`);
    //setTotolPrice(resultadoTotal);

  }
}

  /**
   * Esta función comprobamos si se puede actualizar el precio o no 
   * @param auxTotalPriceAux 
   * @param priceDiscount 
   */
  const checkTripPayment = (auxTotalPriceAux:number) => {
    if (totalSumAux === 0 && (!_checkThereIsTierInBody()&& !_checkThereIsTierCooltraInBody() && !_checkThereIsFreenowInBody() && !_checkThereIsBolt())) {
          setTotalPriceToPay(t("saveToMyTrips"));
      } else if (totalSumAux === 0 && _checkThereIsTierCooltraInBody()) {
        setTotalPriceToPay(t("saveToMyTrips"));
      }
      else if (totalSumAux === 0 && _checkThereIsTierInBody()) {
        setTotalPriceToPay(t("saveToMyTrips"));
      }
      else if (totalSumAux === 0 && _checkThereIsFreenowInBody()) {
        setTotalPriceToPay(t("saveNow"));
      }
      else if (totalSumAux === 0 && _checkThereIsBolt()) {
        setTotalPriceToPay(t("saveNow"));
      }
      else {
        setTotalPriceToPay(`${formatPrice(auxTotalPriceAux)} €`);
    
  
      }
  }


  /**
   * Funcion que va a abrir el modal de los descuentos, tendremos aqui encuentra Nº de PST si es ida o vuelta
   */
  const openModalDiscount =()=>{
    setCurrentStep(0)
    setIsOnePst(false)
    setIsRoundTripAux(false);

    const {transportsIda,transportsVuelta,isRoundTripAux}=getTransportDiscounts(tripSelectedDetails,tripReturnSelectedDetails,t)

    setTransportsDocoDiscountIda(transportsIda)
    setTransportsDocoDiscountVuelta(transportsVuelta)
    setIsRoundTripAux(isRoundTripAux)
    setRouteDiscountLiterals(getRouteDiscountLiterals(t))

    //Comprobamos si hay mas de un viaje, si solo hay un viaje saltamos directamente al paso 1 (meter el codigo)
    if(transportsIda.length===1 &&(transportsVuelta==undefined||transportsVuelta.length===0)){
      setCurrentStep(1)
      setSaveSelectedPst(transportsIda[0])
      setIsOnePst(true)
    }else if(transportsIda.length===0 && transportsVuelta.length===1 ){
      setCurrentStep(1)
      setSaveSelectedPst(transportsVuelta[0])
      setIsOnePst(true)
    }

    setShowModalRouteDiscount(true)

  }




////////////////////////////////////////////


  const handleDeleteCard = () => {
    deleteCard(cardToDelete)
        .then(() => {
            const cardDeleted = cards.find(
                (el: any) => el.id === cardToDelete,
            );
            const isDeleteCardSelected =
                cardDeleted && cardDeleted.selected;
            let aux = cards.filter((el: any) => el.id != cardToDelete);
            if (
                isDeleteCardSelected &&
                aux.find((o: any) => new Date(o.expireDate) > new Date())
            ) {
                aux.find(
                    (o: any) => new Date(o.expireDate) > new Date(),
                ).selected = true;
            }
            setCards(aux);
            setShowDeleteCard(false);
        })
        .catch((error: any) => {
            setShowDeleteCardError(true);
        });
};

  const handleCloseModal = (ev: CustomEvent) => {
    setShowDeleteCard(false);
  }
    const handleCloseModalError = (ev: CustomEvent) => {
    setShowDeleteCardError(false);
  }
  const handleDeleteCheck = (ev: CustomEvent) => {
    setCardToDelete(ev.detail);
    setShowDeleteCard(true);
  }


  return (
    <>
      <PPlannerPayment
        tripType="mono"
        show-payment-component={showPayment}
        show-tyc-component={showTyC}
        summary={summaryInfo}
        literals={pageLiterals}
        creditCardNumber={cardNumber}
        creditCardType={cardType}
        onChangeCardEvent={handleCreditCardChange}
        onAddCardEvent={() => setShowChangeCreditCard(true)}
        onAddDiscountEvent={() => openModalDiscount() }
        total={totalPrice}
        totalToPay={totalPriceToPay}
        showPaymentLiteral={showPaymentLiteral}
        onOpenSummaryEvent={() => setOpenSummaryAmounts(true)}
        privacyPolicyStatus={getPolicy().father}
        onMoreinfoTcEvent={() => setshowPrivacyPolicy(true)}
        onAcceptTcEvent={(e) => {
          setPolicy({
            father:e.detail,
          })
          setPrivacyPolicyAccepted(e.detail);
        }}
        applyDiscount={isApplyDiscount}
        onNextPage={() => nextPage()}
        onBackPage={() => backPage()}
        showPromoComponent={showPromo}
        onCheckPromoCode={(e) => checkPromoCode(e.detail as String)}
        dataCodePromo={dataCodePromo}
        onApplyDocoDiscount={(e)=>applyDocoDiscount(e.detail)}
        literalesModaRemoveDiscount={removeDiscount}
        discountCardLiterals={discountCardLiterals}
        onNavigateMyPoints={() => {
					setNavigate("/app/resume-route");
					navigate("/my-points?goTo=/app/resume-route");
				}}
        discountsList={discountsList}
        isBolt={isBolt}
        isFreenow={isFreenow}
        creditCardExpireDate={cardExpireDate}
        isDefaultCardExpired={isDefaultCardExpired}
        onShowMessageModalEvent={() =>
            setShowMessageExpireDateCard(true)
        }
        onShowModalClearDiscountsEvent={() =>
          setShowModalClearDiscounts(true)
      }
      onShowModaInfoBolt={() =>
        setShowModaInfoBolt(true)
        }
      isInformative={isInformative}
      literalTripInformative={literalTripInformative}
      ></PPlannerPayment>
      <UiToast
            visible={copiedDiscountCode}
            textTitle={pageLiterals.promoCode.discountsAvailable.toast.title}
            textDesc={pageLiterals.promoCode.discountsAvailable.toast.subtitle}
            type="success"
            onHandleClickToast={() => setCopiedDiscountCode(false)}></UiToast>   
      <div className="mt-80">
        <UiModal
          open={showPrivacyPolicy}
          blockOverlay={true}
          onModalClosed={() => setshowPrivacyPolicy(false)}
          nopadding
        >
          <PrivacyPolicy
           privacyPolicyFatherStatus={getPolicy().father}
            privacyPolicyTransports={privacyPolicyTransports}
            literals={JSON.stringify(privacyPolicyLiterals)}
            karhooFleet={fleetKarhooName}
            onCancelModal={() => setshowPrivacyPolicy(false)}
            onAcceptContent={() => setshowPrivacyPolicy(false)}
            onCloseModal={() => setshowPrivacyPolicy(false)}
            onIsActivatedEventEmit={(e) => setPrivacyPolicyAccepted(e.detail)}
  
            
          />
        </UiModal>

        <UiModal open={openSummaryAmounts} blockOverlay={true}>
          <SummaryAmounts
            literals={pageLiterals.desgloseModal}
            departure={tripSelectedDetails?.summaryAmount?.departure || {}}
            arrival={tripReturnSelectedDetails?.summaryAmount?.arrival || {}}
            onCloseSummaryAmountsEvent={() => setOpenSummaryAmounts(false)}
            total={totalPrice}
            discountData={dataCodePromo}
            variant={"resumeRoute"}
          ></SummaryAmounts>
        </UiModal>

        <UiModal open={showChangeCreditCard} blockOverlay={true}>
          <UiModalContent
            onCloseModal={() => setShowChangeCreditCard(false)}
            onOkModal={handleSelectCard}
            literals={paymentMethodModalLiterals}
          >
            <div className="row-cards-container scrollbar">
                <div className="mb-4">
                    <UiMessage
                        show={showMessageExpireDateCard}
                        literal={{ maintext: paymentMethodModalLiterals.expirationWarningText }}
                        type="error"
                        
                    ></UiMessage>
                </div>
              {paymentMethods?.length > 0 && paymentCards()}
              {cardsLinksSection()}
            </div>
          </UiModalContent>
        </UiModal>
        <UiModal open={showExpiredCardModal} blockOverlay={true}>
            <CancelPstError
                literals={getMessageExpiredModal(t)}
                onClickCancelPstErrorButton={() => setShowExpiredCardModal(false)
                }
            ></CancelPstError>
		</UiModal>
        <UiModal open={showUserHasDebtsModal} blockOverlay={true}>
          <UserHasDebtsModal
            literals={userHasDebtsModalLiterals}
            onConfirmButtonEvent={() => setShowUserHasDebtsModal(false)}></UserHasDebtsModal>
        </UiModal>

        <UiModal open={showUpdateTarifModal} blockOverlay={true}>
          <AccessToApp
            literals={JSON.stringify(getUpdatedTarifModalLiterals(t))}
            onCancelModal={() => setShowUpdateTarifModal(false)}
            onOkModal={() => handleUpdateModal()} />
        </UiModal>

        {/* Modal tiempo de espera del taxi */}
        <UiModal open={showCheckTimeoutModal} blockOverlay={true}>
          <RefreshTarifsModal
            literals={checkTimeoutTaxiModalLiterals}
            onConfirmButtonEvent={() => okShowCheckTimeoutModal()} />

        </UiModal>

        {/* Modales desceunto Doco  DESCUENTO MAYOR*/}
        <UiModal open={showModalMajorDiscount} blockOverlay={true}>
          <DiscountWorth 
            literals={discountWorthLiterals}
            onCancelModal={() => {setShowModalMajorDiscount(false); setDataCodePromo({ voucherCode: '',voucherAmount:0, discountType: 'DOCO', isValid: false, reset:false })}}
            onOkModal= {() =>applyDiscountMajor() }
          />
        </UiModal>

        <UiModal open={showModalDiscountNoApplied} blockOverlay={true}>
          <DiscountWorth 
            literals={discountNoAppliedLiterals}
            onCancelModal={() => {continuePayment();setShowModalDiscountNoApplied(false)}}
            onOkModal= {() => setShowModalDiscountNoApplied(false)  }
          />
        </UiModal>

         {/* Modal para la bolsa  postPago*/}
    <UiModal open={showModalProvisionCard} blockOverlay={true}>
          <DiscountWorth 
            image={'information'}
            literals={provisionCardLiterals}
            onCancelModal={() =>  {setShowModalProvisionCard(false);navigate(`/redsys:payCit`);}}
            onOkModal= {() =>setShowModalProvisionCard(false)}
            supplyCardPrice={supplyCardPrice}
          />
        </UiModal>


        {/* Modal cuando no hay metodo de pago añadido */}
        <UiModal open={showMethodPayment} blockOverlay={true}>
           <NoPromoCode
            nameImage={'no_results'} 
            literals={modalErrorMethodPaymentLiterals}
            onClickOkButton={() =>setShowMethodPayment(false) }
          />
        </UiModal>

          {/* Modal cuando no esta aceptadas la politicas */}
          <UiModal open={showErrorPrivacyPolicy} blockOverlay={true}>
           <NoPromoCode
            nameImage={'no_results'} 
            literals={modalErrorPoliciesLiterals}
            onClickOkButton={() =>{setshowPrivacyPolicy(true); setShowErrorPrivacyPolicy(false)} }
          />
        </UiModal>

        <UiModal open={showModalRouteDiscount} nopadding={true} blockOverlay={true}>
        <TravelDiscount
          literals={routeDiscountLiterals}
          outwardTripInfo={transportsDocoDiscountIda}
          returnTripInfo={transportsDocoDiscountVuelta}
          currentStep={currentStep}
          dataCodePromo={dataCodePromo}
          literalesModaRemoveDiscount={removeDiscount}
          codeInputDiscount={codeInputDiscount}
          isOnePst={isOnePst}
          discountsList={discountsList}
          isCheckServicePoints={isCheckServicePoints}
          literalesModalsPoints={literalesModalsPoints}
          onCodeInputDiscountEmit={(e)=>setCodeInputDiscount(e.detail)}
          onHandleApplyDiscounts={(e)=>{applyDocoDiscount(e.detail);}}
          onCloseTravelDiscountModal={() =>{setCodeInputDiscount(null);setShowModalRouteDiscount(false); setCurrentStep(0); setDataCodePromo({ voucherCode: '',voucherAmount:0, discountType: 'DOCO', isValid: false, reset:false });}}
          onHandleTravelsDiscount={(e)=> {setSaveSelectedPst(e?.detail);setCurrentStep(1)}}//Guardamos el viaje marcado y pasamos de step
          onCheckPromoCode={(e) => checkPromoCode(e.detail as String)}
          onCallServicePointsEmit={()=>_getDiscountsList()}
          onShowToastCodePromo={() => setCopiedDiscountCode(true)}
          onGoMyPointsEvent={()=> handleGoMyPoints()}
        />
        </UiModal>

        <UiModal open={showModalErrorDiscount} blockOverlay={true}>
          <NoPromoCode
          literals={modalErrorDiscountLiterals}
          onClickOkButton={() =>setShowModalErrorDiscount(false) }
          />
          </UiModal>

          {/* Modal para eliminar descuento aplicado */}
           <UiModal open={showModalClearDiscounts} blockOverlay={true}>
            <RemoveDiscount
              onOkModal={() => {deleteDocoDiscount();setShowModalClearDiscounts(false)}}
              literals={removeDiscount}
              onCancelModal={() => setShowModalClearDiscounts(false)}
            />
          </UiModal> 
          <UiModal open={showNoPayXModal} blockOverlay={true}>
            <CancelPstError
                literals={getDontPayGoogleApple(t)}
                onClickCancelPstErrorButton={() => setShowNoPayXModal(false)
                }
            ></CancelPstError>
		</UiModal>

{/* Modal de info para los viajes PostPago */}
<UiModal open={showModaInfoBolt} blockOverlay={true}>
          <RefreshTarifsModal
            width={'250px'}
            height={'250px'}
            image={'information'}
            literals={infoBoltLiterals}
            onConfirmButtonEvent={() => setShowModaInfoBolt(false)} />

        </UiModal>

{/* Modal de avis ode borrado de tarjeta*/}
      <UiModal open={showDeleteCard} blockOverlay={true}>
        <AccessToApp
          literals={JSON.stringify(getDeleteCardLiterals(t2))}
          onCancelModal={handleCloseModal}
          onOkModal={handleDeleteCard} />
      </UiModal>
            {/* Error deleting */}
            <UiModal open={showDeleteCardError} blockOverlay={true}>
              <AccessToApp
                literals={JSON.stringify(getDeleteCardErrorLiterals(t2))}
                onCancelModal={handleCloseModalError}
                onOkModal={handleDeleteCard} />
            </UiModal>

        <LegalFooter literals={footerLiterals}></LegalFooter>
      </div>
    </>
  );
};
export const extractNumbers = (str: string) => {
  var c = "0123456789";

  function check(x: any) {
    return c.includes(x) ? true : false;
  }
  if (str) {
    return Array.from(str).reduce((x, y) => (check(y) ? x + y : x), "");
  }
};
